import { ERole } from "library/types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useGetAuthorization } from "state/queries/useGetAuthorization";

const allLanguagesPerCountry = {
  "Country.AT": "de-AT",
  "Country.BA": "bs-BA",
  "Country.BG": "bg-BG",
  "Country.CZ": "cs-CZ",
  "Country.EE": "et-EE",
  "Country.HR": "hr-HR",
  "Country.HU": "hu-HU",
  "Country.LT": "lt-LT",
  "Country.PL": "pl-PL",
  "Country.RO": "ro-RO",
  "Country.RU": "ru-RU",
  "Country.RS": "sr-Latn-RS",
  "Country.SK": "sk-SK",
  "Country.SI": "sl-SI",
  "Country.TR": "tr-TR",
  "Country.UA": "uk-UA",
  "Country.GB": "en-GB",
};

function getLanguagesForCountries(countries, t) {
  return countries.map((country) => {
    const langCode = allLanguagesPerCountry[country] || null;

    const formattedLangCode = langCode === "sr-Latn-RS" ? "sr-RS" : langCode;
    const text = `Language.${formattedLangCode
      ?.replace("-", "_")
      ?.toUpperCase()}`;

    return {
      text: t(text),
      value: langCode,
    };
  });
}

function useGetLanguageOptionsPerUser() {
  const { data } = useGetAuthorization();
  const { t } = useTranslation();

  const userLanguages = getLanguagesForCountries(data?.countries || [], t);

  const languageOptionsPerUser = useMemo(() => {
    const hasAdminRole = data?.roles?.some(
      (role) => role === ERole.GlobalAdmin || role === ERole.ReadonlyGlobalAdmin
    );

    let retVal: any[] = [];
    if (hasAdminRole) {
      retVal = getLanguagesForCountries(Object.keys(allLanguagesPerCountry), t);
    } else {
      retVal = userLanguages;

      if (!retVal.find((item) => item.value === "en-GB")) {
        retVal.push({
          text: t("Language.EN_GB"),
          value: "en-GB",
        });
      }
      if (!retVal.find((item) => item.value === "de-AT")) {
        retVal.push({
          text: t("Language.DE_AT"),
          value: "de-AT",
        });
      }
    }

    return retVal;
  }, [data?.roles, t, userLanguages]);

  return languageOptionsPerUser;
}

export default useGetLanguageOptionsPerUser;
